import { action, computed } from '@ember/object';
import LayoutEditController from 'cio/pods/layout/edit/controller';
import ignorePromiseFailure from 'cio/utils/ignore-promise-failure';
import { inject as service } from '@ember/service';

export default class NewController extends LayoutEditController {
  @service router;

  queryParams = ['starter_layout_id', 'name'];

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }

  @action
  saveLayout() {
    let promise = this.model.save();

    promise.then((model) => {
      this.router.transitionTo('layout.index', model);
    }, ignorePromiseFailure);

    return promise;
  }

  @action
  resetLayout() {
    this.model.rollbackAttributes();
    this.router.transitionTo('layouts');
  }
}
